module.exports = __webpack_public_path__ + "assets/9a169b36c8181d456ded1782bfdfc1a3.svg";